import { SVG_ICONS } from '@shared/constants';

/**
 * Interface for navbar menu items
 * @param label - Label of the menu item
 * @param iconKey - Key of the icon
 * @param active - Whether the menu item is active
 * @param route - Route of the menu item
 * @param iconSize - Size of the icon
 */
export interface NavbarMenuItem {
    label: string;
    iconKey: keyof typeof SVG_ICONS;
    active: boolean;
    route?: string;
    externalUrl?: string;
    iconSize?: number;
}

/**
 * Array of navbar menu items
 * @returns Array of navbar menu items
 */
export const NAVBAR_MENU_ITEMS: NavbarMenuItem[] = [
    {
        label: 'Dashboard',
        iconKey: 'dashboard',
        active: false,
        route: '/dashboard',
    },
    {
        label: 'Dealers',
        iconKey: 'dealers',
        active: true,
        route: '/dealers',
    },
    {
        label: 'Licenses',
        iconKey: 'licenses',
        active: false,
        route: '/licenses',
    },
    {
        label: 'Users',
        iconKey: 'users',
        active: false,
        route: '/users',
    },
    {
        label: 'Media Library',
        iconKey: 'mediaLibrary',
        active: false,
        route: '/media-library',
    },
    {
        label: 'Playlists',
        iconKey: 'play',
        active: false,
        route: '/playlists',
    },
];
